// React Query hooks for /staff/audit/* (feature F-E Phase 4). Mirrors useUsers.ts.
//
// List uses useInfiniteQuery for forward cursor pagination; the page component
// keeps a page-index pointer over the cached pages so "Older" advances
// (fetchNextPage when needed) and "Newer" steps back through already-fetched
// pages (the locked batch-L design — no prevCursor on the backend).

import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import {
  AuditEvent,
  AuditEventPage,
  AuditFilters,
  getAuditEvent,
  listAudit,
} from "../audit";

export const AUDIT_PAGE_SIZE = 50;

export const auditKeys = {
  all: ["audit"] as const,
  list: (filters: AuditFilters) => [...auditKeys.all, "list", filters] as const,
  detail: (id: string) => [...auditKeys.all, "detail", id] as const,
};

export function useAuditList(filters: AuditFilters) {
  return useInfiniteQuery<AuditEventPage>({
    queryKey: auditKeys.list(filters),
    queryFn: ({ pageParam }) =>
      listAudit(filters, {
        cursor: pageParam as string | undefined,
        limit: AUDIT_PAGE_SIZE,
      }),
    initialPageParam: undefined,
    getNextPageParam: (last) => last.nextCursor ?? undefined,
  });
}

export function useAuditEvent(eventId: string | undefined) {
  return useQuery<AuditEvent>({
    queryKey: auditKeys.detail(eventId ?? ""),
    queryFn: () => getAuditEvent(eventId as string),
    enabled: Boolean(eventId),
  });
}
